<template>
  <div>
    <v-data-table
    :loading="loading"
    :search="search"
    :items="items"
    :headers="headers"
    >
      <template v-slot:item.softurl="{ item }">
        <a :href="item.softurl" target="_blank" rel="noopener noreferrer">{{ item.softurl }}</a>
      </template>
      <template v-slot:item.outdated="{ item }">
        <span :class="{'warning--text': item.outdated}">
          {{ item.outdated ? 'Outdated' : 'Up to date' }}
        </span>
      </template>
      <template v-slot:item.script_name="{ item }">
        <span class="app-installer-inline">
          <v-img
            :src="`/static/img/app-installer-icons/${item.logo}`"
            contain
            width="26"
            height="26"
            class="mr-2 app-installer-logo"
          />
          <span class="app-installer-name">{{ item.script_name }}</span>
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <gg-btn
          secondary
          @click="handleLogin(item)"
          :disabled="!item.adminurl && !item.isWp"
          :loading="loadingLogin === item.insid"
          class="mr-2"
        >
          Dashboard
          <v-icon small class="ml-1">mdi-open-in-new</v-icon>
        </gg-btn>
        <gg-btn @click="openModal('delete', item)">Delete</gg-btn>
      </template>
    </v-data-table>

    <delete-modal
      :opened="modals.delete"
      :installation="selectedInstallation"
      :app-name="'Application'"
      @close="closeModal('delete')"
      @deleted="handleFetchApps"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { makeWpLoginUrl } from '@/helpers/wp'
import { versionCompare } from '@/helpers/app-installer'
import DeleteModal from '@/components/Services/Hosting/Shared/Wordpress/Modals/DeleteModal'

export default {
  name: 'InstalledAppsTable',
  components: {
    DeleteModal,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      headers: [
        { text: 'Application', value: 'script_name' },
        { text: 'Status', value: 'outdated' },
        { text: 'URL', value: 'softurl' },
        { text: 'Version', value: 'ver' },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false },
      ],
      modals: {
        delete: false,
      },
      selectedInstallation: null,
      loadingLogin: false,
    }
  },
  computed: {
    ...mapGetters({
      loading: 'app_installer/loadingInstalledApps',
      installedApps: 'app_installer/installedAppsList',
      availableAppsList: 'app_installer/availableAppsList',
    }),
    items () {
      return this.installedApps.map(app => {
        const insInfo = this.availableAppsList.find(a => a.id === app.sid)
        const outdated = versionCompare(app.ver, insInfo?.version || '0') === -1
        return {
          ...app,
          outdated,
        }
      })
    }
  },
  methods: {
    ...mapActions({
      fetchInstalledApps: 'app_installer/fetchInstalledApps',
      reportError: 'reportError',
    }),
    openModal (modalName, installation) {
      this.selectedInstallation = installation
      this.modals[modalName] = true
    },
    closeModal (name) {
      this.modals[name] = false
      this.selectedInstallation = null
    },
    handleFetchApps () {
      this.fetchInstalledApps({ username: this.$route.query.user })
    },
    async handleLogin (installation) {
      if (!installation.isWp && installation.adminurl) {
        window.open(`${installation.softurl}/${installation.adminurl}`, '_blank').focus()
        return
      }

      this.loadingLogin = installation.insid
      try {
        const loginUrl = await makeWpLoginUrl({ insid: installation.insid, username: this.$route.query.user })
        window.open(loginUrl, '_blank').focus()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loadingLogin = false
      }
    },
  },
  mounted () {
    this.handleFetchApps()
  }
}
</script>

<style scoped>
.app-installer-inline {
  display: inline-flex;
  align-items: center;
}

.app-installer-logo {
  display: inline-block !important;
  vertical-align: middle;
}

.app-installer-name {
  display: inline-block;
  vertical-align: middle;
}
</style>
